import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-users-page',
    imports: [RouterOutlet],
    templateUrl: './users-page.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './users-page.component.scss'
})
export class UsersPageComponent {}
